import 'tippy.js/dist/tippy.css';
import './styles.css';
import {
  computePercentage,
  formatCurrency,
} from '../../../../helpers/functions';
import { HorizontalMarker, TriangleMarker } from './Markers';
import { IStrategy, IStrategyAssetTarget } from '../../../../types/model';

export const StrategyProgressBar = ({
  className,
  lastPrice,
  entryPrice,
  currency,
  markers,
}: {
  className?: string;
  lastPrice?: number;
  entryPrice?: number;
  currency: IStrategy['currency'];
  markers?: Pick<IStrategyAssetTarget, 'stopLoss' | 'stopProfit'>[];
}) => {
  const IS_PROFIT = entryPrice! < lastPrice!;
  const entryLastOffset = Math.min(
    50,
    Math.abs(computePercentage(entryPrice!, lastPrice!, 100) / 2)
  );

  const allMarkers = markers?.[0]
    ? [markers[0].stopLoss, markers[0].stopProfit]
    : [];

  return (
    <div
      className={`h-3 rounded-full relative dark:bg-grey-80 ${className || ''}`}
      style={{
        width: '100%',
        boxShadow: 'inset 0px 0px 10px rgba(0,0,0,.1)',
      }}
    >
      <div className="h-full relative mx-4">
        {/* Entry price marker */}
        <HorizontalMarker
          tooltipContent={formatCurrency(entryPrice!, currency!)}
        />
        <div
          className={`
            h-3
            absolute
            w-full
            rounded-${!IS_PROFIT ? 'l' : 'r'}-full
            ${!IS_PROFIT ? 'right' : 'left'}-1/2
            bg-gradient-to-b
            ${!IS_PROFIT ? 'bg-negative' : 'bg-positive'}
          `}
          style={{
            width: `${entryLastOffset}%`,
            boxShadow: 'inset 0px 0px 10px rgba(0,0,0,.15)',
          }}
        >
          <div className="relative h-3 w-full">
            <HorizontalMarker
              className={IS_PROFIT ? 'right-0' : 'left-0'}
              tooltipContent={formatCurrency(lastPrice!, currency!)}
            />
          </div>
        </div>
        {allMarkers.map((targetPrice, index) => (
          <TriangleMarker
            key={index}
            currency={currency}
            entryPrice={entryPrice!}
            targetPrice={targetPrice}
            // withLabel={index === 0 || index === allMarkers.length - 1}
            leftOffset={
              50 -
              Math.abs(computePercentage(entryPrice!, targetPrice, 100) / 2)
            }
          />
        ))}
      </div>
    </div>
  );
};
